var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraderAirdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 84.7",
    style: {
      enableBackground: "new 0 0 85 84.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5BBC6B;}\n\t.st1{fill:#EF3836;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,42.5V31.1H0V11.3h41V0l35.5,20.6L41,42.5z M2.5,28.6h41V38l28.1-17.3L43.6,4.4v9.5h-41V28.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,84.7L8.3,64.1l35.7-21.8v11.4h41v19.8h-41V84.7z M13.2,64l28.2,16.3v-9.5h41V56.2h-41v-9.4L13.2,64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.1,25.6V17h3.4c0.6,0,1.2,0.1,1.6,0.3c0.4,0.2,0.7,0.4,0.9,0.8c0.2,0.3,0.3,0.7,0.3,1.1 c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.3,0.5-0.5,0.6c-0.2,0.2-0.5,0.3-0.8,0.3v0.1c0.3,0,0.6,0.1,0.9,0.3c0.3,0.2,0.5,0.4,0.7,0.7 c0.2,0.3,0.3,0.7,0.3,1.1c0,0.5-0.1,0.9-0.3,1.2c-0.2,0.4-0.6,0.6-1,0.8s-1,0.3-1.6,0.3H8.1z M9.9,20.6h1.3c0.2,0,0.5,0,0.7-0.1 c0.2-0.1,0.3-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.2-0.5-0.3-0.9-0.3H9.9V20.6z M9.9,24.1h1.5 c0.5,0,0.9-0.1,1.1-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.5-0.2-0.7-0.2H9.9 V24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.1,17h1.8v5.6c0,0.6-0.1,1.2-0.4,1.6c-0.3,0.5-0.7,0.8-1.2,1.1c-0.5,0.3-1.2,0.4-1.9,0.4 c-0.7,0-1.3-0.1-1.9-0.4c-0.5-0.3-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6V17h1.8v5.4c0,0.3,0.1,0.6,0.2,0.9 c0.1,0.3,0.3,0.5,0.6,0.6c0.3,0.1,0.6,0.2,0.9,0.2c0.4,0,0.7-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.6-0.6c0.1-0.3,0.2-0.5,0.2-0.9V17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.9,17h2l2,3.7H28l2-3.7h2l-3.1,5.5v3H27v-3L23.9,17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.6,61.7c0-0.3-0.2-0.6-0.4-0.8c-0.3-0.2-0.6-0.3-1-0.3c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.5,0.3 c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0.1,0.3,0.1,0.5,0.2l0.8,0.2 c0.4,0.1,0.7,0.2,1,0.3c0.3,0.1,0.6,0.3,0.8,0.5c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.6,0.2,0.9c0,0.5-0.1,1-0.4,1.4 c-0.3,0.4-0.6,0.7-1.1,0.9c-0.5,0.2-1.1,0.3-1.8,0.3c-0.7,0-1.3-0.1-1.8-0.3c-0.5-0.2-0.9-0.5-1.2-0.9c-0.3-0.4-0.4-0.9-0.4-1.5 h1.8c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.3,0.6,0.4c0.2,0.1,0.5,0.1,0.8,0.1c0.3,0,0.6,0,0.8-0.1c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-0.8-0.3l-0.9-0.2 c-0.7-0.2-1.3-0.4-1.7-0.8c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.5,0.1-1,0.4-1.4c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1-0.3,1.7-0.3 c0.6,0,1.2,0.1,1.7,0.3c0.5,0.2,0.8,0.5,1.1,0.9c0.3,0.4,0.4,0.8,0.4,1.3H54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.6,67.8v-8.6h5.8v1.5h-4v2h3.7v1.5h-3.7v2h4v1.5H57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.8,67.8v-8.6h1.8v7.1h3.7v1.5H64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.5,67.8v-8.6h1.8v7.1H77v1.5H71.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraderAirdrop);
export default __webpack_public_path__ + "static/media/trader-airdrop.844cb7b4716e39788c5f1e1e24b4cb59.svg";
export { ForwardRef as ReactComponent };